export default () => ({
    date: "",
    descriptionCalendar:"",
    descriptionCenter:"",
    status:"active"
  });
  